import React from 'react';
import Section from '../Section';
import SectionContents from '../SectionContents';
import styles from './HowItWorks.module.scss';

import HowItWorksItems from './HowItWorksItems';
import SectionContentsBody from '../SectionContentsBody';
import HowItWorksAssets from './HowItWorksAssets';

function Index() {
  return (
    <Section removePad="bottom" mobilePad="bottom" light>
      <SectionContents
        sizes={{xs: [12, 12], lg: [6, 6]}}
        className={styles['how-it-works-section']}
      >
        <div>
          <SectionContentsBody title="How It Works" />
          <HowItWorksItems />
          <i>
            (IAF MD 28 ensures complete and accurate data across all sources.)
          </i>
        </div>
        <HowItWorksAssets />
      </SectionContents>
    </Section>
  );
}

export default Index;
